module.exports = "<div class=\"process\" style=\"background-image: url('../../../../assets/img/process.jpeg');\">\n</div>\n"